import React, { type CSSProperties } from "react";
import JoyStickBackground from "../../assets/icons/joystick_background_2.png";
import JoystickIcon from "../../assets/icons/joystick.png";

interface JoystickProps {
  isActive: boolean;
  outerRef?: React.RefObject<HTMLDivElement>;
  onTouchStart: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchMove: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchEnd: (e: React.TouchEvent<HTMLDivElement>) => void;
  onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
  transform: () => string;
  style?: CSSProperties;
  className?: string;
}

export const Joystick: React.FC<JoystickProps> = ({
  isActive,
  outerRef,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onMouseDown,
  transform,
  style = {},
  className,
}) => {
  return (
    <div
      ref={outerRef}
      className={className}
      style={{
        ...baseStyles.joystick,
        ...style,
      }}
    >
      <div
        style={baseStyles.analogOuter}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onTouchCancel={onTouchEnd}
        onMouseDown={onMouseDown}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div
          style={{
            ...baseStyles.analogInner,
            ...(isActive && baseStyles.analogActive),
            transform: transform(),
          }}
        />
      </div>
    </div>
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  joystick: {
    width: "120px",
    height: "120px",
    touchAction: "none",
    backgroundImage: `url(${JoyStickBackground})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  analogOuter: {
    width: "100%",
    height: "100%",
    position: "relative",
    touchAction: "none",
    pointerEvents: "auto",
    WebkitTapHighlightColor: "transparent",
    WebkitTouchCallout: "none",
    userSelect: "none",
  },
  analogInner: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    left: "50%",
    cursor: "pointer",
    transition: "background 0.1s",
    pointerEvents: "none",
    touchAction: "none",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url(${JoystickIcon})`,
    outline: "none",
    userSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "transparent",
    WebkitUserSelect: "none",
    KhtmlUserSelect: "none",
    MozUserSelect: "none",
  },
  analogActive: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
};
